module.exports = __webpack_public_path__ + "img/04tab-funky.6ce03a78.png";